<template>
    <div class="popup active" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>본인인증</h2>
                    <button type="button" class="popup__close" @click="cancelCert"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="text-list">
                        <p class="font-black">{{ '이대' + this.$store.getters.getHostNm }} 홈페이지에서 제공하는 서비스 중
                            본인인증이 필요한 서비스를
                            사용하기 위한 절차입니다.</p>
                        <p><span class="font-main" style="font-weight: 700;">환자번호가 없는</span> 신규 환자인 경우 예약페이지에서 본인인증을 하시어 환자번호를 발급받으시기
                            바랍니다.
                            처음 1회 인증 후 예약완료를 하시면 반복적인 본인인증 절차 없이
                            모든 서비스를 평생
                            이용하실 수 있습니다.</p>
                        <p class="c-red">내 진료 정보의 환자번호 조회는 환자번호가 있는 기존 환자의 등록번호만 조회 가능합니다.</p>
                    </div>

                    <h3>고유식별정보의 수집·이용</h3>
                    <div class="text-box-scroll">
                        <p>
                            1. 수집하는 고유식별정보 항목<br>
                            -이름, 주민등록번호(또는 외국인등록번호)<br>
                            2. 수집·이용 목적<br>
                            -진료와 직접 관련된 진료 신청, 진단, 검사, 치료, 수납 결제 등 관련 업무<br>
                            를 수행하기 위한 환자번호 확인 시
                        </p>
                    </div>
                    <div class="checkbox-wrap">
                        <label>
                            <input type="checkbox" name="agree" v-model="agree" >
                            <span class="checkbox-btn"></span>
                            <p>위 고유식별정보의 수집·이용에 동의합니다.</p>
                        </label>
                    </div>

                    <h3>주민등록번호</h3>
                    <div class="input-text-num">
                        <label class="input-text-num">
                            <input type="text" maxlength="6" v-model="frrn" @input="this.$commonUtils.numberOnly">
                            <span>-</span>
                            <input type="password" maxlength="7" v-model="brrn" @input="this.$commonUtils.numberOnly">
                        </label>
                    </div>

                    <div class="botton-wrap type02">
                        <a href="javascript:;" class="sub-button c-main mo-none" @click="cancelCert" >취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="nameCheck" >본인인증</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                agree: false,
                memName: this.$store.state.myInfoStore.memName,
                frrn: '',
                brrn: '',
                popupShow: false
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            cancelCert() {
                this.$emit('cancelNameCheck')
            },
            nameCheck() {
                if(this.agree !== true){
                    alert("고유식별정보 처리 동의가 필요합니다.");

                    return;
                }

                if(this.frrn == '' || this.brrn == ''){
                    alert("개인정보 입력이 필요합니다.");

                    return;
                }

                this.axios.get(this.api.member.nameCheck, {
                    params: {
                        gubun: 'R',
                        reg01: this.frrn,
                        reg02: this.brrn,
                        name: this.$store.state.myInfoStore.name
                    }
                }).then(response => {
                    const data = response.data

                    if(data.result === "1"){

                        this.axios.get(this.api.member.encData,{
                            params: {
                                hostNm: this.$store.state.hospStore.hostName
                            }
                        }).then(encResponse => {
                            const data = encResponse.data

                            window.open('', 'popup', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');

                            const form = document.createElement("form");
                            form.method = "POST";
                            form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
                            form.target = "popup"; // 새 창에서 요청을 보낼 수 있도록 설정

                            // 데이터 파라미터 추가
                            const encodeData = document.createElement("input");
                            encodeData.type = "hidden";
                            encodeData.name = "EncodeData";
                            encodeData.value = data.sEncData;

                            // 데이터 파라미터 추가
                            const m = document.createElement("input");
                            m.type = "hidden";
                            m.name = "m";
                            m.value = "checkplusSerivce";

                            form.appendChild(encodeData);
                            form.appendChild(m);

                            document.body.appendChild(form);
                            form.submit();

                            document.body.removeChild(form);

                        })
                    }else{
                        alert(data.resultMsg)
                    }

                });
            },
        },
    }
</script>